import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'

import { ModalConfirm } from 'mailup-web-components'

const ModalConfirmPhoneNumber = ({ show, number, onConfirm, onCancel }) => {
  const intl = useIntl()

  return (
    <ModalConfirm
      show={show}
      showClose
      closeOnOverlayClick
      title={intl
        .formatMessage({
          id: 'Load.SmsSendingWizard.RequestVerificationModalTitle',
          0: number
        })
        .replace('{0}', number)}
      message={intl.formatMessage({
        id: 'Load.SmsSendingWizard.RequestVerificationModalBody'
      })}
      variant='primary'
      stringConfirm={intl.formatMessage({
        id: 'Load.SmsSendingWizard.RequestVerificationModalCta'
      })}
      onClickConfirm={onConfirm}
      stringCancel={intl.formatMessage({ id: 'Load.MailupCommon.Cancel' })}
      onClickCancel={onCancel}
    />
  )
}

export default ModalConfirmPhoneNumber

ModalConfirmPhoneNumber.propTypes = {
  show: PropTypes.bool,
  number: PropTypes.any,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func
}
